import { createContext, useContext } from "react";

type DraftContextValue = {
  isReadOnly: boolean;
};

const DraftContext = createContext<DraftContextValue>({ isReadOnly: false });
export default DraftContext;

export function useDraftContext() {
  return useContext(DraftContext);
}
